// Fonte única das linhas de negócio Workwell. Todos os módulos importam daqui.
export const LINHAS = ['Mind', 'Vitality', 'Academy', 'Moments'];

export const LINHA_COR = {
  'Mind':     '#691FB1',
  'Vitality': '#27AE60',
  'Academy':  '#57B1DD',
  'Moments':  '#FF357B',
};

export const LINHA_ICON = {
  'Mind':     '\u{1F9E0}',
  'Vitality': '\u{1F4AA}',
  'Academy':  '\u{1F393}',
  'Moments':  '\u{1F389}',
};
